import { Injectable } from '@angular/core';
import { CityActions } from '@city/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class GeoPointEffects {
  updateUserGeoPoint$: Observable<CityActions.BusinessRegionLoad> = createEffect(() =>
    this.actions$.pipe(
      ofType(CityActions.USER_GEO_POINT_UPDATE),
      map((action: CityActions.UserGeoPointUpdate) => new CityActions.BusinessRegionLoad(action.payload)),
    ),
  );

  constructor(private actions$: Actions) {}
}
